import { set, unset } from 'immutadot'

import {
    INIT_QUERY_PARAMS,
    UPDATE_SEARCH_QUERY_PARAMS,
} from './actions'

export const queryParams = (state = {}, action) => {

    switch (action.type)
    {
        case INIT_QUERY_PARAMS:
            return {
                ...action.params
            }
        case UPDATE_SEARCH_QUERY_PARAMS:
            const {key, value} = action.searchParam
            if(! key)
            {
                return state
            }
            if(! value)
            {
                return unset(state, `search.${key}`)
            }

            return set(state, `search.${key}`, value)
        default:
            return state
    }
}
